import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Shell, PageComponent, FormComponent, Page, PageService, FormInput, Redirection } from '@tytapp/common';
import { User } from '@tytapp/models';
import { UsersApi, CommunicationPrefsApi, ApiCommunicationPref, CommunicationPrefRequest } from 'api';
import { UserService } from '../user.service';

@Component({
  selector: 'app-communication-preference',
  templateUrl: './communication-preference.component.html',
  styleUrls: ['./communication-preference.component.scss']
})
export class CommunicationPreferenceComponent extends PageComponent implements FormComponent {

  constructor(
    pageService: PageService,
    private userService: UserService,
    private redirection: Redirection,
    private communicationPrefsApi: CommunicationPrefsApi
  ) {
    super(pageService);
  }

  user: User;

  @FormInput()
  newsletter: boolean = false;
  
  @FormInput()
  newsletter_weekly: boolean = false;
  
  @FormInput()
  army: boolean = false;
  
  @FormInput()
  shop: boolean = false;

  submitSuccess = false;

  communicationPref: ApiCommunicationPref[];

  async init() {
    this.subscribe(this.userService.userChanged, async user => {
      this.user = user;
      if (!this.user) {
        this.redirection.go('/');
        return;
      }

      this.communicationPref = <ApiCommunicationPref[]> await this.communicationPrefsApi.getCommunicationPrefs().toPromise();
    });
  }

  get emailPrefs(): ApiCommunicationPref[] {
    if (!this.communicationPref)
      return [];

    return this.communicationPref.filter(x => x.provider === 'email');
  }

  submitting = false;

  async submit() {
    let prefs : CommunicationPrefRequest[] = this.emailPrefs.map(x => ({ 
      provider: x.provider,
      provider_id: x.provider_id,
      allowed: x.allowed
    }));

    let param = {
      communication_prefs : prefs
    }
    try {
      this.submitting = true;
      await this.communicationPrefsApi.patchCommunicationPrefs(param as any).toPromise();
      this.submitting = false;
      this.submitSuccess = true;
    } catch(e) {
      this.submitting = false;
      if (e.json)
        e = e.json();
    
      console.error('Error while updating communication prefs: ');
      console.error(e.message || e.error);
      console.dir(e);

      this.showError(e.message || e.error || 'Uh oh, an error occurred while updating your preferences. Please try again- if the issue persists please contact support.');
    }
  }

}
